import React, { Component } from 'react'

import { db } from '../../../firebase.js'

import Datetime from 'react-datetime'
import '../../../assets/css/react-datetime.css'

import { convertDateMomentToFullDate, formatDateForFeaturedLink } from '../../../helpers.js'

import Dropzone from 'react-dropzone'
import axios from 'axios'

const CLOUDINARY_UPLOAD_PRESET = 'keepeurekastrong'
const CLOUDINARY_UPLOAD_URL = 'https://api.cloudinary.com/v1_1/dierker/image/upload'

class AdminFeatured extends Component {
	constructor() {
		super()
		this.state = {
			whichToUpdate: "",
			newText: "",
			newDate: "",
			newLink: "",
			newImgUrl: "",
			newImgFile: "",
			//properties: text, date, link, image
			topFeatured: {},
			botFeatured: {}
		}
	}

	componentDidMount() {
		const dbFeaturedLinks = db.ref('featuredLinks')
    dbFeaturedLinks.on('value', (snapshot) => {
			let featuredLinks = snapshot.val()
			this.setState({
				topFeatured: featuredLinks.top,
				botFeatured: featuredLinks.bot
			})
		})
	}
	
	componentWillUnmount() {
		const dbFeaturedLinks = db.ref('featuredLinks')
		dbFeaturedLinks.off()		
  }

	handleWhichToUpdateChange = (e) => {
		this.setState({
			whichToUpdate: e.target.value
		})
	}
  handleTextChange = (e) => {
    this.setState({
      newText: e.target.value
    })
	}
	handleLinkChange = (e) => {
    this.setState({
      newLink: e.target.value
    })
	}
	handleDateChange = (momentObj) => {
		this.setState({
			newDate: momentObj
		})
	}
	handleImgChange = (files) => {
		this.setState({
			newImgFile: files[0]
		})
	}

	handleFeaturedLinkSubmit = (e) => {
		e.preventDefault()
		//make sure all form fields are filled out, if not, abort
		if (this.state.whichToUpdate === "" ||
				this.state.newText === "" ||
				this.state.newDate === "" ||
				this.state.newLink === "" ||
				this.state.newImgFile === "") {
					return console.log("error: all fields must be filled out to submit a featured link")
				}
		//format date for saving in firebase
		let dateObject = convertDateMomentToFullDate(this.state.newDate)
		//build the formdata for axios, which submits a post request to cloudinary with the image file
		let formData = new FormData()
    formData.append("file", this.state.newImgFile)
    formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET)
    axios
			.post(CLOUDINARY_UPLOAD_URL, formData)
			.then((result) => {
				let newImgUrlOnCloudinary = result.data.secure_url
				//build the object that will be sent to firebase
				let newFeaturedLink = {
					text: this.state.newText,
					date: dateObject.getTime(),
					link: this.state.newLink,
					img: newImgUrlOnCloudinary
				}
				//send the new featuredLink object to firebase and overwrite (update) the old one in that slot
				const dbFeaturedLinks = db.ref('featuredLinks')
				if (this.state.whichToUpdate === "topFeatured") { dbFeaturedLinks.update({top: newFeaturedLink}) }
				if (this.state.whichToUpdate === "botFeatured") { dbFeaturedLinks.update({bot: newFeaturedLink}) }
				this.setState({
					whichToUpdate: "",
					newText: "",
					newDate: "",
					newLink: "",
					newImgUrl: "",
					newImgFile: ""
				})
			})
			.catch((err) => {console.log(err)}) 
	}


  render() {
		let top = this.state.topFeatured
		let bot = this.state.botFeatured
		let instructionsOrNewImgName = ""
		if (this.state.newImgFile === "") { 
			instructionsOrNewImgName = "Image (click or drag image here)" 
		} else { 
			instructionsOrNewImgName = <span className="black">{this.state.newImgFile.name}</span>
		} 
		let topFormattedDate = formatDateForFeaturedLink(top.date)
		let botFormattedDate = formatDateForFeaturedLink(bot.date)
		
    return (
      <div className="flex flex-column mb7">
				<section className="mb5 w-50-l">
					<div className="pathway f2 mb2 white bg-dark-gray pa3 card">
						CHANGE FEATURED LINKS & IMAGES
					</div>
					<article className="open-sans-cond bg-white card pa2 w-100 flex flex-column gray">

						<div className="flex flex-column flex-row-ns align-center mb2 f3">
							<div>
								<input 
									type="radio" 
									name="whichLink" 
									value="topFeatured" 
									className="mr2 v-mid"
									checked={this.state.whichToUpdate === "topFeatured"}
									onChange={this.handleWhichToUpdateChange}/> 
								<label className="mr3 v-mid">
									Update top link
								</label>
							</div>
							<div>
								<input 
									type="radio" 
									name="whichLink" 
									value="botFeatured" 
									className="mr2 v-mid"
									checked={this.state.whichToUpdate === "botFeatured"}
									onChange={this.handleWhichToUpdateChange}/> 
								<label className="v-mid">
									Update bottom link
								</label>
							</div>
						</div>

						<div className="flex flex-column mb2">
							<input 
								placeholder="Text"
								name="newText" 
								className="headline-input pa2 open-sans-cond f3 b--moon-gray b--solid bw025" 
								value={this.state.newText} 
								onChange={this.handleTextChange}/>
						</div>

						<Datetime className="open-sans-cond f3 mb2"
							inputProps={{placeholder: "Date",
													className: "b--moon-gray b--solid bw025 w-100",
													name: "newDate"}}
							timeFormat={false}
							value={this.state.newDate}
							onChange={this.handleDateChange}
							closeOnSelect={true}/>

						<div className="mb2 flex flex-column">
							<input 
								placeholder="Link (include http://)"
								name="newLink" 
								className="pa2 open-sans-cond f3 lh-copy b--moon-gray b--solid bw025" 
								value={this.state.newLink} 
								onChange={this.handleLinkChange}/>
						</div>

						<Dropzone
							multiple={false}
							accept="image/*"
							className="gray pointer mb2 pa2 open-sans-cond f3 lh-copy b--moon-gray b--solid bw025"
							onDrop={this.handleImgChange}>
							{instructionsOrNewImgName}
						</Dropzone>

						<div onClick={(e) => {this.handleFeaturedLinkSubmit(e)}} 
								className="dib link pathway pointer self-end bg-animate dim bg-gray ph3 pv2 f3 f2-ns tc near-white">
									UPDATE FEATURED LINK
						</div>
					</article>
				</section>

				<section className="w-100 w-30-l bg-moon-gray flex flex-column">
					<div className="pathway f2 mb2 white bg-dark-gray pa3 card">
						FEATURED LINKS
					</div>
					<aside className="leftbar pathway bg-white card pa2 tc">
						<a href={top.link} 
							style={{backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.60),rgba(0, 0, 0, 0.60)),url("+top.img+")"}}
							target="_blank" 
							className="featured dim no-underline mb2 pa2 f5 h4 fw1 f3-l near-white open-sans-cond flex flex-column justify-center"
							rel="noopener noreferrer">
							<p>
								{top.text}<br/>
								{topFormattedDate}
							</p>
						</a>
						<a href={bot.link} 
							style={{backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.60),rgba(0, 0, 0, 0.60)),url("+bot.img+")"}}
							target="_blank" 
							className="featured dim no-underline pa2 f5 h4 fw1 f3-l near-white open-sans-cond flex flex-column justify-center"
							rel="noopener noreferrer">
							<p>
								{bot.text}<br/>
								{botFormattedDate}
							</p>
						</a>
					</aside>
				</section>
      </div>
    )
  }
}

export default AdminFeatured


// WEBPACK FOOTER //
// ./src/components/admin/pages/AdminFeatured.js